<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" ref="form" label-width="130px">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item prop="areaName" label="区域名称">
              {{ formData.areaName || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="itemList" label="检查项">
              <p v-for="(item, index) of formData.itemList" :key="index">{{ item.itemName }}</p>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>

  </div>
</template>

<script>

export default {
  name: 'AreaMangeDetail',
  data() {
    return {
      formData: {
        areaName: '', // 区域名称
        itemList: [] // 检查项列表
      }
    }
  },
  created() {
    if (this.areaId) {
      this.loadData()
    }
  },
  computed: {
    areaId() {
      return this.$route.query.areaId
    }
  },
  methods: {
    loadData() {
      this.$axios.get(this.$apis.wspb.selectPaFactoryAreaByAreaId, { areaId: this.areaId }).then(res => {
        this.formData = res
      })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}
</style>
